import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components/macro';
import { GridRow, GridColumn } from '@eriksdigital/atomic-ui/components';
import { Icon } from '@eriksdigital/atomic-ui/components';
import { AddAltIcon } from '@eriksdigital/atomic-ui/components/Icons';
import {
  selectDocumentsSorted,
  selectIsLoadingDocuments,
  selectUploadStatus,
} from './selectors';
import { actions } from './slice';
import {
  certificatesTableColumns,
  mapCertificatesToDataTableRow,
} from './utils';
import { DataTableColumn } from 'app/components/DataTable/types';
import { DataTable } from 'app/components/DataTable';
import t from 'locales/translation';
import { ButtonSecondary } from 'app/elements/Buttons';
import EquipmentAttachmentsSidebar from 'app/containers/EquipmentAttachments/components/EquipmentAttachmentsSidebar';
import { TableContainer } from '../EquipmentDetail/components/WorkOrdersTable';
import useEquipmentAttachments from './hooks/useEquipmentAttachments';

export const EquipmentAttachments = () => {
  const { resourceTypes, fetchResourceTypes } = useEquipmentAttachments();
  const dispatch = useDispatch();
  const documents = useSelector(selectDocumentsSorted);
  const isLoading = useSelector(selectIsLoadingDocuments);
  const { isUploading } = useSelector(selectUploadStatus);
  const documentRows = documents.map(mapCertificatesToDataTableRow);

  const columns: Array<DataTableColumn> = certificatesTableColumns();

  useEffect(() => {
    fetchResourceTypes();
  }, [fetchResourceTypes]);

  useEffect(() => {
    if (!!resourceTypes?.length) {
      dispatch(actions.getDocumentsAndCertificates());
    }
  }, [dispatch, resourceTypes]);

  return (
    <Wrapper>
      <GridRow>
        <GridColumn desktop={12} mobile={12}>
          <TableHeader>
            <ButtonSecondary
              onClick={() => dispatch(actions.setIsUploading(true))}
            >
              <Icon as={AddAltIcon} size="sz20" />
              {t('Attachments.Upload')}
            </ButtonSecondary>
          </TableHeader>
          <TableContainer>
            <DataTable
              columns={columns}
              data={documentRows}
              isLoading={isLoading}
            />
          </TableContainer>
        </GridColumn>
      </GridRow>
      {isUploading && <EquipmentAttachmentsSidebar />}
    </Wrapper>
  );
};

export const Wrapper = styled.div`
  padding: 12px;
  margin-top: ${({ theme }) => theme.spacing.sp8};

  ${({ theme }) => theme.breakpoints.tabletLandscape`
    padding: 0;
    margin-top: ${({ theme }) => theme.spacing.sp16};
  `};
`;

const TableHeader = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.sp16};
  display: flex;
  justify-content: flex-end;
`;
